import { Link } from "react-router-dom";
import * as Icons from "lucide-react";

export default function CategoriaCard({ categoria }) {
  const Icone = Icons[categoria.icone] || Icons.Sparkles;
  return (
    <Link
      to={`/categoria/${categoria.slug}`}
      className="group relative block rounded-sm border border-[var(--cor-borda)] bg-[var(--cor-fundo-2)]/40 p-8 transition-all duration-500 hover:-translate-y-1 hover:border-[var(--cor-dourado)]/40 hover:bg-[var(--cor-fundo-3)]/60"
      data-testid={`categoria-card-${categoria.slug}`}
    >
      <Icone className="h-8 w-8 text-[var(--cor-dourado)] transition-transform duration-500 group-hover:scale-110" strokeWidth={1.2} />
      <h3 className="font-display text-xl text-[var(--cor-texto)] mt-5 leading-tight">{categoria.label}</h3>
      <p className="font-serif text-sm text-[var(--cor-texto-2)] mt-2 leading-relaxed">{categoria.descricao}</p>
    </Link>
  );
}
